import React, { useState } from 'react';

function ProfileForm({ user, onComplete, onCancel }) {
  const [nom, setNom] = useState(user?.nom || '');
  const [prenom, setPrenom] = useState(user?.prenom || '');
  const [email, setEmail] = useState(user?.email || '');
  const [telephone, setTelephone] = useState(user?.telephone || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const isEditMode = !!onCancel;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!nom.trim() || !prenom.trim() || !email.trim() || !telephone.trim()) {
      setError('Tous les champs sont obligatoires');
      return;
    }
    if (telephone.length !== 10) {
      setError('Le numéro de téléphone doit contenir 10 chiffres');
      return;
    }

    try {
      setLoading(true);
      setError('');
      const token = localStorage.getItem('assurextract_token');
      const res = await fetch('/api/auth/profile', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          nom: nom.trim(),
          prenom: prenom.trim(),
          email: email.trim().toLowerCase(),
          telephone: telephone.trim()
        })
      });
      const data = await res.json();
      if (data.user) {
        onComplete(data.user);
      } else {
        setError(data.error || 'Erreur lors de la sauvegarde');
      }
    } catch {
      setError('Erreur de connexion au serveur');
    } finally {
      setLoading(false);
    }
  };

  const handleTelChange = (e) => {
    const digits = e.target.value.replace(/\D/g, '').slice(0, 10);
    setTelephone(digits);
  };

  const inputStyle = {
    width: '100%',
    padding: '14px 16px',
    borderRadius: '10px',
    border: '1px solid #cbd5e1',
    background: '#f8fafc',
    color: '#1e293b',
    fontSize: '16px',
    outline: 'none',
    boxSizing: 'border-box',
    transition: 'border-color 0.2s'
  };

  const labelStyle = {
    display: 'block',
    color: '#64748b',
    fontSize: '13px',
    marginBottom: '6px',
    textAlign: 'left'
  };

  const isValid = nom.trim() && prenom.trim() && email.trim() && telephone.length === 10;

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f0f4f8 0%, #e2e8f0 100%)',
      padding: '20px'
    }}>
      <div style={{
        background: '#ffffff',
        border: '1px solid #e2e8f0',
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
        borderRadius: '16px',
        padding: '48px',
        maxWidth: '440px',
        width: '100%',
        textAlign: 'center'
      }}>
        <h1 style={{
          color: '#1e293b',
          fontSize: '24px',
          fontWeight: '700',
          marginBottom: '8px'
        }}>
          {isEditMode ? 'Mon profil' : 'Bienvenue !'}
        </h1>
        <p style={{
          color: '#64748b',
          fontSize: '14px',
          marginBottom: '32px'
        }}>
          {isEditMode ? 'Modifiez vos informations' : 'Complétez votre profil pour commencer'}
        </p>

        {error && (
          <p style={{ color: '#ef4444', fontSize: '13px', marginBottom: '16px' }}>
            {error}
          </p>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '16px' }}>
            <label style={labelStyle}>Prénom</label>
            <input
              type="text"
              value={prenom}
              onChange={(e) => setPrenom(e.target.value)}
              placeholder="Votre prénom"
              autoFocus
              style={inputStyle}
            />
          </div>

          <div style={{ marginBottom: '16px' }}>
            <label style={labelStyle}>Nom</label>
            <input
              type="text"
              value={nom}
              onChange={(e) => setNom(e.target.value)}
              placeholder="Votre nom"
              style={inputStyle}
            />
          </div>

          <div style={{ marginBottom: '16px' }}>
            <label style={labelStyle}>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="votre@email.com"
              style={inputStyle}
            />
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={labelStyle}>Téléphone (10 chiffres)</label>
            <input
              type="tel"
              value={telephone}
              onChange={handleTelChange}
              placeholder="0612345678"
              inputMode="numeric"
              maxLength={10}
              style={inputStyle}
            />
            {telephone.length > 0 && telephone.length < 10 && (
              <p style={{ color: '#f59e0b', fontSize: '12px', marginTop: '4px', textAlign: 'left' }}>
                {telephone.length}/10 chiffres
              </p>
            )}
          </div>

          <button
            type="submit"
            disabled={!isValid || loading}
            style={{
              width: '100%',
              padding: '14px',
              borderRadius: '10px',
              border: 'none',
              background: isValid && !loading
                ? 'linear-gradient(135deg, #3b82f6, #8b5cf6)'
                : '#e2e8f0',
              color: '#fff',
              fontSize: '16px',
              fontWeight: '600',
              cursor: isValid && !loading ? 'pointer' : 'not-allowed',
              transition: 'all 0.2s'
            }}
          >
            {loading ? 'Enregistrement...' : isEditMode ? 'Enregistrer' : 'Commencer'}
          </button>

          {isEditMode && (
            <button
              type="button"
              onClick={onCancel}
              style={{
                width: '100%',
                padding: '12px',
                marginTop: '12px',
                borderRadius: '10px',
                border: '1px solid #e2e8f0',
                background: 'transparent',
                color: '#64748b',
                fontSize: '14px',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
            >
              Annuler
            </button>
          )}
        </form>
      </div>
    </div>
  );
}

export default ProfileForm;
